import React from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

class WrappedPerfectScrollbar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, suppressScrollX, ...rest } = this.props;
    return (
      <PerfectScrollbar
        options={{ suppressScrollX: true }}
        containerRef={ref => (ref ? (ref.tabIndex = -1) : null)}
        {...rest}
      >
        {children}
      </PerfectScrollbar>
    );
  }
}

export default WrappedPerfectScrollbar;